import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Nav } from "./components/sections/Nav";
import { Hero } from "./components/sections/Hero";
import { Marquee } from "./components/sections/Marquee";
import { Services } from "./components/sections/Services";
import { Portfolio } from "./components/sections/Portfolio";
import { Process } from "./components/sections/Process";
import { Pricing } from "./components/sections/Pricing";
import { WhyUs } from "./components/sections/WhyUs";
import { Testimonials } from "./components/sections/Testimonials";
import { FAQ } from "./components/sections/FAQ";
import { Footer } from "./components/sections/Footer";
import { FloatingWA } from "./components/sections/FloatingWA";

const Landing = () => {
    useEffect(() => {
        const els = document.querySelectorAll(".reveal");
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return (
        <main data-testid="landing-page" className="bg-jws-bg text-jws-text">
            <Nav />
            <Hero />
            <Marquee />
            <Services />
            <Portfolio />
            <Process />
            <Pricing />
            <WhyUs />
            <Testimonials />
            <FAQ />
            <Footer />
            <FloatingWA />
        </main>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
